<template>
  <div align="center">
    <v-container fluid>
      <br /><br /><br />
      <v-slide-y-transition v-if="!haveQueryParams">
        <div outlined v-if="init" id="buscador">
          <v-flex>
            <v-card
              class="card2 my-background"
              style="
                border-top-left-radius: 25px;
                border-bottom-right-radius: 25px;
                width: 650px;
              "
            >
              <v-row justify="center">
                <v-col cols="1" class="mr-1">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <strong>
                        <v-icon
                          v-on="on"
                          style="border-radius: 100%; border: 4px solid"
                          class="orange--text"
                          @click="irHome()"
                          large
                        >
                          mdi-account-search
                        </v-icon>
                      </strong>
                    </template>
                    <span>Buscador de Cliente</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="10"></v-col>
                <v-col cols="10">
                  <!-- Mostrar la imagen del cliente seleccionado -->
                  <p v-if="imageData">
                    <img
                      :src="imageData.logo2"
                      :alt="imageData.nombre"
                      style="max-height: 120px; border-radius: 5px"
                    />
                    <br />
                    <strong class="text-body-2 mt-4">
                      En esta sección, podrás visualizar tu N° de Orden.
                    </strong>
                  </p>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    outlined
                    label="Ingresar Nº de Orden"
                    :loading="loading"
                    :rules="validId"
                    prepend-inner-icon="mdi-magnify"
                    v-model.trim="idOrden"
                  />
                  <router-link
                    :to="{
                      name: 'empresas',
                      query: { codigo: imageData.id_cliente, orden: idOrden },
                    }"
                  >
                    <v-btn
                      style="
                        border-top-left-radius: 25px;
                        border-bottom-right-radius: 25px;
                        font-size: 10px;
                      "
                      :disabled="!inputWithData"
                      dark
                      class="orange"
                      @click="searchTracking"
                    >
                      Buscar
                    </v-btn>
                  </router-link>
                </v-col>
              </v-row>
            </v-card>
            <br /><br />
          </v-flex>
        </div>
      </v-slide-y-transition>
      <div loading id="tracking" v-else>
        <Timeline
          dense
          :id-cliente="idCliente"
          :id-orden="idOrden"
          :style="windowX < 1270 ? 'zoom:90%;' : null"
        >
        </Timeline>
      </div>
      <br /><br />
    </v-container>
  </div>
</template>

<script>
import Timeline from "@/components/Timeline.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import * as easings from "vuetify/es5/services/goto/easing-patterns";

export default {
  components: {
    Timeline, // Aquí asegúrate de que 'Timeline' esté correctamente registrado
  },
  data() {
    return {
      loading: false,
      filtro: "",
      altTest: null,
      tcard: "tWhite",
      init: false,
      lastStatus: 1,
      idCliente: this.$route.query.id ?? null, // Este valor ahora lo obtendremos del store
      idOrden: this.$route.query.orden ?? null,
      tracking: false,
      valid: false,
      validId: [
        (v) => !!v || "Debes ingresar el número de búsqueda primero",
        (v) =>
          (v && v.length <= 30) || "Extensión máxima admitida de 30 caracteres",
      ],
      duration: 800,
      offset: -80,
      easing: "easeInOutCubic",
      easings: Object.keys(easings),
      texto: "azul",
      breakpoint: null,
      windowX: 0,
      windowY: 0,
    };
  },
  created() {
    if (this.theme == "light") {
      this.tcard = "tWhite";
      this.texto = "azul";
    } else if (this.theme == "dark") {
      this.tcard = "tBlack";
      this.texto = "null";
    } else {
      this.tcard = "tWhite";
      this.texto = "azul";
    }
    setTimeout(() => {
      this.init = true;
    }, 100);
  },
  mounted() {
    this.onResize();
    // En lugar de obtener el cliente por la query, usamos selectedCourier del store
    this.getOrderById();
  },
  computed: {
    ...mapGetters(["mapImagen"]),
    ...mapState([
      "loading",
      "theme",
      "buscador",
      "couriers",
      "selectedCourier",
    ]),

    // Usamos selectedCourier directamente desde el store
    imageData() {
      console.log(this.$route.query.codigo);
      
      return this.selectedCourier || {};
    },
    inputWithData() {
      return Boolean(this.idCliente && this.idOrden);
    },
    haveQueryParams() {
      return Boolean(this.$route.query.orden && this.$route.query.codigo);
    },
    target() {
      const value = this[this.type];
      if (!isNaN(value)) return Number(value);
      else return value;
    },
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
    cuentaFiltradas: function () {
      return this.cuenta.filter((cuenta) => {
        return cuenta.name.toLowerCase().match(this.filtro.toLowerCase());
      });
    },
  },
  components: {
    Timeline,
  },
  watch: {
    loading: function () {
      if (this.loading == false) {
        setTimeout(() => {
          this.$vuetify.goTo("#tracking", this.options);
        }, 100);
      }
    },
    theme: function () {
      if (this.theme == "light") {
        this.tcard = "tWhite";
        this.texto = "azul";
      } else {
        this.tcard = "tBlack";
        this.texto = null;
      }
    },
  },

  methods: {
    ...mapMutations([
      "setIdTrack",
      "setLoading",
      "setOrdenClienteFinal",
      "setStorerKey",
      "setUrl",
      "setBuscador",
    ]),
    searchTracking() {
      this.tracking = false;
      this.setLoading(false);
      this.getOrderById();
    },
    getOrderById() {
      if (this.inputWithData) {
        this.setOrdenClienteFinal(this.idOrden);
        var conf = this.imageData;
        this.setStorerKey(conf.id_cliente);
        this.tracking = true;
        this.setBuscador(false);
      } else {
        this.setBuscador(true);
      }
    },
    async resetId() {
      await this.setOrdenClienteFinal(null);
      this.tracking = false;
      return true;
    },
    onResize() {
      this.windowX = window.innerWidth;
      this.windowY = window.innerHeight;
    },
    irHome() {
      this.$router.push("/");
    },
  },
};
</script>
